/// <amd-module name="Build/ApprovalsPanel/ChecksTelemetryService" />

import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

export class TelemetryConstants {
    public static Area = "Checks";
}

export class Features {
    public static ApprovalReassign = "ApprovalReassign";
}

export function publishEvent(pageContext: IVssPageContext, feature: string, properties: { [key: string]: any }) {
    const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");

    try {
        telemetryService.publishEvent(TelemetryConstants.Area, feature, properties);
    }
    catch (e) {
        console.error(Utils_String.format("[TelemetryService.logProperties]: Error in logging Customer Intelligence data. Error: {0}", e.message));
    }
}

